import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagesComponent } from 'src/common/components';
import { Form, FormElement, FormElementValidators } from 'src/common/form';
import {Auth, AuthenticationResetModel, ChangePasswordModel} from 'src/common/security';
import { environment } from 'src/environments/environment';
import { TranslationManager } from 'src/common/translation';





@Component({
    selector: 'change-password',
    templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {

    form: Form = new Form();
    passwordNotMatch: boolean = false;
    passwordToken: string;
    readonly environment = environment;
    translationManager = TranslationManager;

    constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        this.initForm();

         this.activatedRoute.paramMap.subscribe((value: any) => {
            this.passwordToken = value.params.id;
         });
    }

    changePassword() {
        this.passwordNotMatch = false;

        if (this.form.isValid()) {
            var newPassword = this.form.elements['newpassword'].value;
            var confirmedPassword = this.form.elements['confirmpassword'].value;
            var username = this.form.elements['username'].value;
            var oldpassword = this.form.elements['oldpassword'].value;

            if(newPassword != confirmedPassword) {
                this.passwordNotMatch = true;
                return;
            }

            let resetModel: ChangePasswordModel = new ChangePasswordModel();
            resetModel.newPassword = newPassword;
            resetModel.username = username;
            resetModel.oldPassword = oldpassword;

            Auth.changePassword(resetModel).then(() => {
                MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Корисничка лозинка је успешно промењена')]);

                this.router.navigate(['/login']);
            });
        }
    }

    private initForm() {

        this.form.elements['username'] = new FormElement();
        this.form.elements['username'].state.mandatory = true;
        this.form.elements['username'].onValidation = FormElementValidators.stringValidator;

        this.form.elements['oldpassword'] = new FormElement();
        this.form.elements['oldpassword'].state.mandatory = true;
        this.form.elements['oldpassword'].onValidation = FormElementValidators.stringValidator;

        this.form.elements['newpassword'] = new FormElement();
        this.form.elements['newpassword'].state.mandatory = true;
        this.form.elements['newpassword'].onValidation = FormElementValidators.stringValidator;

        this.form.elements['confirmpassword'] = new FormElement();
        this.form.elements['confirmpassword'].state.mandatory = true;
        this.form.elements['confirmpassword'].onValidation = FormElementValidators.stringValidator;
    }

}
